module.exports = __webpack_public_path__ + "img/left.a63c2ba0.png";